jQuery(document).ready(function($) {
    
    if($('body').hasClass('page-template-template-home')) {

    	// Draw SVG
    	var drawSVGArray = [];
    	var drawSVGCount = 0;
    	var newDrawSVG;

    	$('.draw-svg svg').each(function() {
    		newDrawSVG = $(this).drawsvg({
				duration: 2000,
				stagger: 0
			});

    		$(this).attr('data-drawsvgid', drawSVGCount);

    		drawSVGArray.push(newDrawSVG);
			drawSVGCount = drawSVGCount + 1;
		});

    	// Generate dot
		$('body').append('<span class="home-central-animation"><span class="home-central-animation__dot"></span></span>');
		var $centralAnimation = $('.home-central-animation');

		// Get dot start position
		function generateCentralAnimationElements() {
			var centralAnimationTopPos = $('.homeintro__image img').offset().top + $('.homeintro__image img').height();
			$centralAnimation.css('top', centralAnimationTopPos + 'px');

			var centralAnimationMaxHeight = $('.home-central-animation-finish').offset().top - $centralAnimation.offset().top;
			$centralAnimation.css('max-height', centralAnimationMaxHeight + 'px');
		}

		function centralAnimationHeight() {
			var centralAnimationHeight = $(window).scrollTop() + ($(window).height() * 0.8) - $centralAnimation.offset().top;
			if(centralAnimationHeight > $centralAnimation.height()) {
				$centralAnimation.css('height', centralAnimationHeight + 'px');
			}
		}

		function homeAnimationFadeIn() {
			$('.home-animation-fadein').each(function() {
				if($('.home-central-animation__dot').offset().top >= $(this).offset().top) {
					$(this).addClass('home-animation--done');
				}
			});

			$('.draw-svg svg:not(.drawsvg-done)').each(function() {
				if($('.home-central-animation__dot').offset().top >= $(this).offset().top + $(this).height()) {
			        $(this).addClass('drawsvg-done');
					var currentDrawID = $(this).data('drawsvgid');
					drawSVGArray[currentDrawID].drawsvg('animate');
				}
			});
		}

		function homeTreeAnimation() {
			if($('.home-central-animation__dot').offset().top - 300 >= $('#hometree-svg').offset().top) {
				$('#hometree-leaves-svg').addClass('active');
			}

			if($('.home-central-animation__dot').offset().top >= $('.hometree-roots').offset().top) {
				$('.hometree-roots-item--middle').addClass('active');

				setTimeout(function() {
					$('.hometree-roots-item--side').addClass('active');
				}, 1500); 
			}
		}

		$(window).load(function() {
			generateCentralAnimationElements();
			centralAnimationHeight();
			homeAnimationFadeIn();
			homeTreeAnimation();
		});

		$(window).scroll(function() {
			centralAnimationHeight();
			homeAnimationFadeIn();
			homeTreeAnimation();
		});

		$(window).resize(function() {
			generateCentralAnimationElements();
			centralAnimationHeight();
			homeAnimationFadeIn();
			homeTreeAnimation();
		});

    }
});
